import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class CommonMessageService {

  constructor() { }

  saveMessage() {
    return Swal.fire({
      // title: 'Saved Successfully!',
      text: 'Saved Successfully!',
      // position: 'top',
      timer: 2500,
      showCancelButton: false,
      showConfirmButton: false,
      icon: 'success'
    }).then(
      function () { },
      function (dismiss) {
        if (dismiss === 'timer') {
        }
      }
    )
  }

  updateMessage() {
    return Swal.fire({
      // title: 'Updated Successfully!',
      text: 'Updated Successfully!',
      // position: 'top',
      timer: 2500,
      showCancelButton: false,
      showConfirmButton: false,
      icon: 'success'
    }).then(
      function () { },
      function (dismiss) {
        if (dismiss === 'timer') {
        }
      }
    )
  }

  submitMessage() {
    return Swal.fire({
      // title: 'Updated Successfully!',
      text: 'Submitted Successfully!',
      // position: 'top',
      timer: 2500,
      showCancelButton: false,
      showConfirmButton: false,
      icon: 'success'
    }).then(
      function () { },
      function (dismiss) {
        if (dismiss === 'timer') {
        }
      }
    )
  }

  uploadMessage() {
    return Swal.fire({
      // title: 'Updated Successfully!',
      text: 'Uploaded Successfully!',
      // position: 'top',
      timer: 2500,
      showCancelButton: false,
      showConfirmButton: false,
      icon: 'success'
    }).then(
      function () { },
      function (dismiss) {
        if (dismiss === 'timer') {
        }
      }
    )
  }

  deleteMessage() {
    return Swal.fire({
      // title: 'Deleted Successfully!',
      text: 'Deleted Successfully!',
      // position: 'top',
      timer: 2000,
      showCancelButton: false,
      showConfirmButton: false,
      icon: 'success'
    }).then(
      function () { },
      function (dismiss) {
        if (dismiss === 'timer') {
        }
      }
    )
  }

  acceptMessage() {
    return Swal.fire({
      // title: 'Updated Successfully!',
      text: 'Accepted Successfully!',
      // position: 'top',
      timer: 2500,
      showCancelButton: false,
      showConfirmButton: false,
      icon: 'success'
    }).then(
      function () { },
      function (dismiss) {
        if (dismiss === 'timer') {
        }
      }
    )
  }

  approveMessage() {
    Swal.fire({
      // title: 'Approved Successfully!',
      text: 'Approved Successfully!',
      // position: 'top',
      timer: 2000,
      showCancelButton: false,
      showConfirmButton: false,
      icon: 'success'
    }).then(
      function () { },
      function (dismiss) {
        if (dismiss === 'timer') { }
      })
  }

  resentMessage() {
    Swal.fire({
      // title: 'Approved Successfully!',
      text: 'Resend Successfully!',
      // position: 'top',
      timer: 2000,
      showCancelButton: false,
      showConfirmButton: false,
      icon: 'success'
    }).then(
      function () { },
      function (dismiss) {
        if (dismiss === 'timer') { }
      })
  }

  transferMessage() {
    Swal.fire({
      // title: 'Approved Successfully!',
      text: 'Transfered Successfully!',
      // position: 'top',
      timer: 2000,
      showCancelButton: false,
      showConfirmButton: false,
      icon: 'success'
    }).then(
      function () { },
      function (dismiss) {
        if (dismiss === 'timer') { }
      })
  }
  
  swalAlertWithIcon(tittle,text,icon){
    Swal.fire({
      // title: 'Approved Successfully!',
      text: text,
      // position: 'top',
      timer: 2000,
      showCancelButton: false,
      showConfirmButton: false,
      icon: icon
    }).then(
      function () { },
      function (dismiss) {
        if (dismiss === 'timer') { }
      })
  }

  swalAlertWithoutIcon(tittle,text){
    Swal.fire({
      text: text,
      confirmButtonColor:'#800000',
      position:'top',
      allowOutsideClick: false,
    })
  }

}
